import { PSpinner } from '@porsche-design-system/components-react';

type LoaderProps = {
    height?: 'auto' | 'screen';
};

const Loader = ({ height = 'auto' }: LoaderProps) => (
    <div
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '12px',
            // eslint-disable-next-line no-nested-ternary
            height: height === 'auto' ? 'auto' : height === 'screen' ? '100vh' : undefined,
        }}
    >
        <PSpinner inert={undefined} size={{ base: 'small', l: 'medium' }} />
    </div>
);

export default Loader;
